const React = require('react');

module.exports = ({className, disablePaddings, children}) => (
  <div className={
    `r9 bgFAFAFA bxsh4c0.25 pt14 ph21 pb22 p0.disablePaddings`
    + (className ? ` ${className}` : '')
    + (disablePaddings ? ` disablePaddings` : '')
  }>
    {children}
  </div>
);